<template>
  <div class="home-container">
    <div class="home-content">
      <div class="header">
        <div class="title">基本数据概括</div>
        <div class="head">
          <div class="li lis">
            <div class="label">位置</div>
            <div class="value">{{ userInfo.name }}</div>
          </div>
          <div class="li lis">
            <div class="label">交付时间</div>
            <el-input
              class="input"
              @blur="changeValue"
              v-model="form.deliverTime"
              placeholder="请输入"
            ></el-input>
          </div>
          <div class="li">
            <div class="label">绿化率</div>
            <div class="unit">
              <el-input
                class="input"
                v-model="form.greenRate"
                @blur="changeValue"
                type="number"
                :min="0"
                placeholder="请输入"
              ></el-input>
              <span>%</span>
            </div>
          </div>
          <div class="li lis">
            <div class="label">容积率</div>
            <el-input
              class="input"
              v-model="form.volumeRate"
              @blur="changeValue"
              type="number"
              :min="0"
              placeholder="请输入"
            ></el-input>
          </div>
          <div class="li">
            <div class="label">楼栋数</div>
            <div class="unit">
              <el-input
                class="input"
                v-model="form.ridgepoleCount"
                @blur="changeValue"
                type="number"
                :min="0"
                placeholder="请输入"
              ></el-input>
              <span>栋</span>
            </div>
          </div>
          <div class="li">
            <div class="label">单元数</div>
            <div class="unit">
              <el-input
                class="input"
                v-model="form.unitCount"
                @blur="changeValue"
                type="number"
                :min="0"
                placeholder="请输入"
              ></el-input>
              <span>个</span>
            </div>
          </div>
          <div class="li">
            <div class="label">户数</div>
            <div class="unit">
              <el-input
                class="input"
                v-model="form.householdCount"
                @blur="changeValue"
                type="number"
                :min="0"
                placeholder="请输入"
              ></el-input>
              <span>户</span>
            </div>
          </div>
          <div class="li">
            <div class="label">小区居民数量</div>
            <div class="unit">
              <el-input
                class="input"
                v-model="form.residentCount"
                @blur="changeValue"
                type="number"
                :min="0"
                placeholder="请输入"
              ></el-input>
              <span>个</span>
            </div>
          </div>
          <div class="li">
            <div class="label">业主满意率</div>
            <div class="unit">
              <el-input
                class="input"
                v-model="form.ownerSatisfyCount"
                @blur="changeValue"
                type="number"
                :min="0"
                placeholder="请输入"
              ></el-input>
              <span>%</span>
            </div>
          </div>
        </div>
        <div class="typeList">
          <div class="ul">
            <div class="li">
              <div class="label">占地面积</div>
              <div class="unit">
                <el-input
                  class="input"
                  v-model="form.totalArea"
                  size="small"
                  type="number"
                  @blur="changeValue"
                  :min="0"
                  placeholder="请输入"
                ></el-input>
                <span>㎡</span>
              </div>
            </div>
            <div class="li">
              <div class="label">机关业主户数</div>
              <div class="unit">
                <el-input
                  class="input"
                  @blur="changeValue"
                  v-model="form.organOwnerHouseholdCount"
                  size="small"
                  type="number"
                  :min="0"
                  placeholder="请输入"
                ></el-input>
                <span>户</span>
              </div>
            </div>
            <div class="li">
              <div class="label">建筑面积</div>
              <div class="unit">
                <el-input
                  class="input"
                  v-model="form.buildArea"
                  @blur="changeValue"
                  size="small"
                  type="number"
                  :min="0"
                  placeholder="请输入"
                ></el-input>
                <span>㎡</span>
              </div>
            </div>
            <div class="li">
              <div class="label">地上建筑面积</div>
              <div class="unit">
                <el-input
                  class="input"
                  v-model="form.landArea"
                  @blur="changeValue"
                  size="small"
                  type="number"
                  :min="0"
                  placeholder="请输入"
                ></el-input>
                <span>㎡</span>
              </div>
            </div>
            <div class="li">
              <div class="label">地下建筑面积</div>
              <div class="unit">
                <el-input
                  class="input"
                  size="small"
                  v-model="form.underLandArea"
                  @blur="changeValue"
                  type="number"
                  :min="0"
                  placeholder="请输入"
                ></el-input>
                <span>㎡</span>
              </div>
            </div>
          </div>
          <div class="ul">
            <div class="li">
              <div class="label">住宅面积</div>
              <div class="unit">
                <el-input
                  class="input"
                  v-model="form.residenceArea"
                  @blur="changeValue"
                  size="small"
                  type="number"
                  :min="0"
                  placeholder="请输入"
                ></el-input>
                <span>㎡</span>
              </div>
            </div>
            <div class="li">
              <div class="label">商铺套数</div>
              <div class="unit">
                <el-input
                  class="input"
                  v-model="form.retailShopCount"
                  @blur="changeValue"
                  size="small"
                  type="number"
                  :min="0"
                  placeholder="请输入"
                ></el-input>
                <span>个</span>
              </div>
            </div>
            <div class="li">
              <div class="label">商铺面积</div>
              <div class="unit">
                <el-input
                  class="input"
                  v-model="form.retailShopArea"
                  @blur="changeValue"
                  size="small"
                  type="number"
                  :min="0"
                  placeholder="请输入"
                ></el-input>
                <span>㎡</span>
              </div>
            </div>
            <div class="li">
              <div class="label">物业管理用房面积</div>
              <div class="unit">
                <el-input
                  class="input"
                  v-model="form.propertyManageArea"
                  @blur="changeValue"
                  size="small"
                  type="number"
                  :min="0"
                  placeholder="请输入"
                ></el-input>
                <span>㎡</span>
              </div>
            </div>
            <div class="li">
              <div class="label">物业经营用房面积</div>
              <div class="unit">
                <el-input
                  class="input"
                  size="small"
                  v-model="form.propertyOperateArea"
                  @blur="changeValue"
                  type="number"
                  :min="0"
                  placeholder="请输入"
                ></el-input>
                <span>㎡</span>
              </div>
            </div>
          </div>
          <div class="ul">
            <div class="li">
              <div class="label">地面停车位</div>
              <div class="unit">
                <el-input
                  class="input"
                  v-model="form.landParkingSpace"
                  @blur="changeValue"
                  size="small"
                  type="number"
                  :min="0"
                  placeholder="请输入"
                ></el-input>
                <span>个</span>
              </div>
            </div>
            <div class="li">
              <div class="label">地下停车位</div>
              <div class="unit">
                <el-input
                  class="input"
                  v-model="form.underLandParkingSpace"
                  @blur="changeValue"
                  size="small"
                  type="number"
                  :min="0"
                  placeholder="请输入"
                ></el-input>
                <span>个</span>
              </div>
            </div>
            <div class="li">
              <div class="label">电梯数量</div>
              <div class="unit">
                <el-input
                  class="input"
                  v-model="form.liftCount"
                  @blur="changeValue"
                  size="small"
                  type="number"
                  :min="0"
                  placeholder="请输入"
                ></el-input>
                <span>个</span>
              </div>
            </div>
            <div class="li">
              <div class="label">消火栓数量</div>
              <div class="unit">
                <el-input
                  class="input"
                  v-model="form.fireHydrantCount"
                  @blur="changeValue"
                  size="small"
                  type="number"
                  :min="0"
                  placeholder="请输入"
                ></el-input>
                <span>个</span>
              </div>
            </div>
            <div class="li">
              <div class="label">灭火器数量</div>
              <div class="unit">
                <el-input
                  class="input"
                  size="small"
                  v-model="form.annihilatorCount"
                  @blur="changeValue"
                  type="number"
                  :min="0"
                  placeholder="请输入"
                ></el-input>
                <span>个</span>
              </div>
            </div>
            <div class="li">
              <div class="label">高配房数量</div>
              <div class="unit">
                <el-input
                  class="input"
                  size="small"
                  v-model="form.heightWingCount"
                  @blur="changeValue"
                  type="number"
                  :min="0"
                  placeholder="请输入"
                ></el-input>
                <span>个</span>
              </div>
            </div>
          </div>
          <div class="ul">
            <div class="li">
              <div class="label">管理人员</div>
              <div class="unit">
                <el-input
                  class="input"
                  v-model="form.manageStaff"
                  @blur="changeValue"
                  size="small"
                  type="number"
                  :min="0"
                  placeholder="请输入"
                ></el-input>
                <span>个</span>
              </div>
            </div>
            <div class="li">
              <div class="label">客服人员</div>
              <div class="unit">
                <el-input
                  class="input"
                  v-model="form.customerServiceStaff"
                  @blur="changeValue"
                  size="small"
                  type="number"
                  :min="0"
                  placeholder="请输入"
                ></el-input>
                <span>个</span>
              </div>
            </div>
            <div class="li">
              <div class="label">工程人员</div>
              <div class="unit">
                <el-input
                  class="input"
                  v-model="form.projectStaff"
                  @blur="changeValue"
                  size="small"
                  type="number"
                  :min="0"
                  placeholder="请输入"
                ></el-input>
                <span>个</span>
              </div>
            </div>
            <div class="li">
              <div class="label">秩序维护人员</div>
              <div class="unit">
                <el-input
                  class="input"
                  @blur="changeValue"
                  v-model="form.maintenanceStaff"
                  size="small"
                  type="number"
                  :min="0"
                  placeholder="请输入"
                ></el-input>
                <span>个</span>
              </div>
            </div>
            <div class="li">
              <div class="label">保洁绿化人员</div>
              <div class="unit">
                <el-input
                  class="input"
                  @blur="changeValue"
                  size="small"
                  v-model="form.cleaningStaff"
                  type="number"
                  :min="0"
                  placeholder="请输入"
                ></el-input>
                <span>个</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="typeList">
          <div class="title">收费情况</div>
          <div class="cont">
            <div class="li lis">
              <div class="label">全年应收</div>
              <div class="unit">
                <el-input
                  class="input inputs"
                  @blur="changeValue"
                  v-model="form.yearReceivablePrice"
                  size="small"
                  type="number"
                  :min="0"
                  placeholder="请输入"
                ></el-input>
                <span>元</span>
              </div>
            </div>
            <div class="li">
              <div class="label">今日收缴</div>
              <div class="value">
                {{ detail.billCensus.dayPrice }} <span>元</span>
              </div>
            </div>
            <div class="li">
              <div class="label">本月收缴</div>
              <div class="value">
                {{ detail.billCensus.monthPrice }} <span>元</span>
              </div>
            </div>
            <div class="li">
              <div class="label">全年收缴</div>
              <div class="value">
                {{ detail.billCensus.yearPrice }} <span>元</span>
              </div>
            </div>
            <div class="li">
              <div class="label">本年收缴率</div>
              <div class="value">{{ form.yearRate }} <span>%</span></div>
            </div>
          </div>
        </div>
        <div class="typeList typeLists">
          <div class="title">设备巡检</div>
          <div class="cont">
            <div class="li">
              <div class="label">今日巡检</div>
              <div class="value">
                {{ detail.deviceData.dayCount }} <span>次</span>
              </div>
            </div>
            <div class="li">
              <div class="label">本月巡检</div>
              <div class="value">
                {{ detail.deviceData.monthCount }} <span>次</span>
              </div>
            </div>
            <div class="li">
              <div class="label">本年巡检</div>
              <div class="value">
                {{ detail.deviceData.yearCount }} <span>次</span>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="typeList">
          <div class="title">巡更情况</div>
          <div class="cont">
            <div class="li">
              <div class="label">今日巡更完成率</div>
              <div class="value">
                {{ detail.patrol.dayRate }} <span>%</span>
              </div>
            </div>
            <div class="li">
              <div class="label">本月巡更完成率</div>
              <div class="value">
                {{ detail.patrol.monthRate }} <span>%</span>
              </div>
            </div>
            <div class="li">
              <div class="label">本年巡更完成率</div>
              <div class="value">
                {{ detail.patrol.yearRate }} <span>%</span>
              </div>
            </div>
          </div>
        </div> -->
      </div>
      <div class="footer">
        <div class="title">工单情况</div>
        <div class="foot">
          <div class="left">
            <div class="statistics">
              <div class="li">
                <div class="label">今日上报工单数</div>
                <div class="value">{{ detail.orderWork.dayAddCount }}</div>
              </div>
              <div class="li">
                <div class="label">今日完成工单数</div>
                <div class="value">{{ detail.orderWork.daySuccessCount }}</div>
              </div>
              <div class="li">
                <div class="label">待完成工单数</div>
                <div class="value">{{ detail.orderWork.waitCount }}</div>
              </div>
              <div class="li">
                <div class="label">本月完成工单数</div>
                <div class="value">{{ detail.orderWork.waitCount }}</div>
              </div>
              <div class="li">
                <div class="label">本年完成工单数</div>
                <div class="value">{{ detail.orderWork.yearSuccessCount }}</div>
              </div>
            </div>
            <div class="orderList">
              <img class="notice" src="../assets/imgs/notice.png" alt="" />
              <div class="scroll">
                <vueSeamlessScroll
                  :data="vehicleRecordListData"
                  :class-option="defaultOption"
                >
                  <div class="list">
                    <div
                      class="li"
                      v-for="(item, ind) in vehicleRecordListData"
                      :key="ind"
                      @click="gotoOrderwork(item)"
                    >
                      <span class="nottitle">报修:{{ item.des }}</span>
                      <span>上报时间:{{ item.createTime }}</span>
                      <span>状态:{{ funStatus(item.status) }}</span>
                      <i class="el-icon-arrow-right"></i>
                    </div>
                  </div>
                </vueSeamlessScroll>
              </div>
            </div>
          </div>
          <div class="right">
            <div ref="myChart1" class="myChart"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 新增模态框 -->
    <el-dialog
      title="详情"
      :visible.sync="isAddModal"
      width="50%"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="addData"
        label-width="90px"
        label-position="center"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="订单编号" prop="orderWorkNo">
              <el-input
                v-model="addData.orderWorkNo"
                placeholder="无"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="报修类型" prop="orderCategoryName">
              <el-input
                v-model="addData.orderCategoryName"
                placeholder="无"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="报修人" prop="userName">
              <el-input
                v-model="addData.userName"
                placeholder="无"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="房屋信息" prop="houseNumber">
              <el-input
                v-model="addData.houseNumber"
                placeholder="无"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="报修内容" prop="des">
              <el-input
                v-model="addData.des"
                placeholder="无"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="报修图片" prop="createTime">
              <div v-if="addData.img" style="cursor: pointer" v-viewer>
                <img
                  :src="item"
                  v-for="(item, ind) in addData.img.split(',')"
                  :key="ind"
                  alt=""
                  style="width: 100px; height: 100px"
                />
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="受理人" prop="handleUser">
              <el-input
                v-model="addData.handleUser"
                placeholder="无"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="报修地址" prop="address">
              <el-input
                v-model="addData.address"
                placeholder="无"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="分发时间" prop="distributeTime">
              <el-input
                v-model="addData.distributeTime"
                placeholder="无"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="分发人员" prop="handleUser">
              <el-input
                v-model="addData.handleUser"
                placeholder="无"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="接收时间" prop="receiveTime">
              <el-input
                v-model="addData.receiveTime"
                placeholder="无"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="接收人员" prop="handleUser">
              <el-input
                v-model="addData.handleUser"
                placeholder="无"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="报修时间" prop="createTime">
              <el-input
                v-model="addData.createTime"
                placeholder="无"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="完成时间" prop="completeTime">
              <el-input
                v-model="addData.completeTime"
                placeholder="无"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="完成图片" prop="createTime">
              <div v-if="addData.completeImg" style="cursor: pointer" v-viewer>
                <img
                  :src="item"
                  v-for="(item, ind) in addData.completeImg.split(',')"
                  :key="ind"
                  alt=""
                  style="width: 100px; height: 100px"
                />
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="完成备注" prop="completeDesc">
              <el-input
                v-model="addData.completeDesc"
                placeholder="无"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="评价等级" prop="evaluateScore">
              <el-select
                v-model="addData.evaluateScore"
                disabled
                clearable filterable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="评价时间" prop="evaluateTime">
              <el-input
                v-model="addData.evaluateTime"
                placeholder="无"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="评价内容" prop="evaluateDesc">
              <el-input
                v-model="addData.evaluateDesc"
                placeholder="无"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isAddModal = false">确 定</el-button>
        <!-- <el-button type="primary" @click="submit" :loading="btnLoading"
            >确 定</el-button
          > -->
      </span>
    </el-dialog>
  </div>
</template>

<script>
import vueSeamlessScroll from "vue-seamless-scroll";
export default {
  components: {
    vueSeamlessScroll,
  },
  name: "home",
  data() {
    return {
      form: {},
      detail: {
        summarize: {
          num: "12",
          eaer: "16800平米",
        },
        deviceData: {
          dayCount: 0,
          monthCount: 0,
          yearCount: 0,
        },
        patrol: {
          dayRate: 0,
          monthRate: 0,
          yearRate: 0,
        },
        billCensus: {
          dayPrice: 0,
          monthPrice: 0,
          monthSuccessCount: 0,
          yearRate: 0,
          yearPrice: 0,
          yearReceivablePrice: 0,
        },
        orderWork: {
          dayAddCount: 0,
          daySuccessCount: 0,
          monthSuccessCount: 0,
          waitCount: 0,
          yearSuccessCount: 0,
          orderWorkList: [],
        },
        baseDetail: {},
      },
      defaultOption: {
        limitMoveNum: 5,
        // singleHeight: 200,
        hoverStop: true,
        direction: 1,
        openWatch: true,
        step: 0.5,
      },
      vehicleRecordListData: [],
      chart1: null,
      userInfo: {},
      isAddModal: false,
      addData: {},
      options: [
        {
          value: 1,
          label: "非常满意",
        },
        {
          value: 2,
          label: "满意",
        },
        {
          value: 3,
          label: "一般",
        },
        {
          value: 0,
          label: "暂无",
        },
      ],
    };
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("park_data"));
    this.devicePatrolCensus();
    this.patrolCensus();
    this.baseBillCensus();
    this.orderWorkCensus();
    this.orderWorkProportion();
  },
  methods: {
    gotoOrderwork(item) {
      this.addData = item;
      this.isAddModal = true;
      // let path = "";
      // if (item.status == 0) {
      //   path = "/unhandled";
      // } else if (item.status == 1) {
      //   path = "/distributed";
      // } else if (item.status == 2) {
      //   path = "/accepted";
      // } else if (item.status == 3) {
      //   path = "/completed";
      // } else if (item.status == 4) {
      //   path = "/evaluated";
      // } else if (item.status == 5) {
      //   path = "/canceled";
      // } else if (item.status == 6) {
      //   path = "/rejected";
      // }
      // this.$router.push({ path, query: { id: item.id } });
    },
    changeValue() {
      this.$Apis.baseaddUp(this.form).then((res) => {
        if (res.code == 200) {
          this.baseDetail();
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    funStatus(row) {
      if (row == 0) {
        return "待分发";
      } else if (row == 1) {
        return "待接收";
      } else if (row == 2) {
        return "进行中";
      } else if (row == 3) {
        return "已完成";
      } else if (row == 4) {
        return "已评价";
      } else if (row == 5) {
        return "已取消";
      } else if (row == 6) {
        return "已拒绝";
      }
    },
    // 概括详情
    baseDetail() {
      this.$Apis.baseDetail().then((res) => {
        if (res.code == 200) {
          this.form = res.data;
          if (res.data.yearReceivablePrice) {
            this.form.yearRate = (
              (this.detail.billCensus.yearPrice /
                res.data.yearReceivablePrice) *
              100
            ).toFixed(2);
          }
        }
      });
    },
    // 设备巡检
    devicePatrolCensus() {
      this.$Apis.devicePatrolCensus({ type: 1 }).then((res) => {
        if (res.code == 200) {
          this.detail.deviceData = res.data;
        }
      });
    },
    // 巡更
    patrolCensus() {
      this.$Apis.patrolCensus({ type: 1 }).then((res) => {
        if (res.code == 200) {
          this.detail.patrol = res.data;
        }
      });
    },
    // 缴费统计
    baseBillCensus() {
      this.$Apis.baseBillCensus({ type: 1 }).then((res) => {
        this.baseDetail();
        if (res.code == 200) {
          this.detail.billCensus = res.data;
        }
      });
    },
    // 工单情况
    orderWorkCensus() {
      this.$Apis.orderWorkCensus({ type: 1 }).then((res) => {
        if (res.code == 200) {
          this.detail.orderWork = res.data;
          this.vehicleRecordListData = res.data.orderWorkList;
        }
      });
    },
    // 工单情况占比图
    orderWorkProportion() {
      this.$Apis.orderWorkProportion({ type: 1 }).then((res) => {
        if (res.code == 200) {
          this.initOptions1(res.data);
        }
      });
    },
    initOptions1(row) {
      let data = [];
      let allCont = 0;

      if (row.length > 0) {
        row.forEach((ele) => {
          ele.value = ele.count;
          allCont += ele.count;
        });
        data = row;
      }
      let options = {
        title: {
          text: "各类工单占比图",
          // bottom: "left",
          left: "center",
        },
        tooltip: {
          trigger: "item",
          formatter: function (param) {
            var content = "<div>";
            content += "<p>分类名称：" + param.data.name + "</p>";
            content +=
              "<p>工单占比：" +
              ((param.data.value / allCont) * 100).toFixed(2) +
              "%" +
              "</p>";
            content += "</div>";
            return content;
          },
        },
        series: [
          {
            name: "工单数量",
            type: "pie",
            radius: "50%",
            data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      this.chart1 = this.$echarts.init(this.$refs.myChart1);
      this.chart1.setOption(options);
    },
  },
};
</script>

<style lang="scss" scoped>
.home-container {
  padding: 10px;
  padding-top: 5px;
}
.home-content {
  padding: 15px;
  border-radius: 5px;
  background: #fff;
  .header {
    width: 100%;
    .title {
      width: 100%;
      font-size: 18px;
      font-weight: bold;
      color: #1a202c;
      text-align: left;
      margin-bottom: 30px;
      position: relative;
    }
    .title::after {
      content: "";
      position: absolute;
      top: 6px;
      left: -8px;
      width: 4px;
      height: 15px;
      background: #5a9cf8;
    }
    .head {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .li {
        width: 9%;
        display: flex;
        align-items: center;
        flex-direction: column;
        border-bottom: 1px solid #dedede;
        // padding-bottom: 10px;
        .label {
          font-size: 14px;
          color: #676779;
          font-weight: bold;
          margin-bottom: 5px;
          padding-right: 13px;
        }
        .value {
          font-size: 16px;
          color: #1a202c;
          font-weight: bold;
          height: 30px;
          line-height: 42px;
        }
        .unit {
          display: flex;
          // align-items: center;
          line-height: 42px;
        }
        .input {
          height: 30px;
          /deep/.el-input__inner {
            border: none !important;
            text-align: center;
            font-size: 16px;
            color: #1a202c;
            font-weight: bold;
          }
        }
      }
      .lis {
        padding-bottom: 10px;
        .label {
          padding: 0;
        }
      }
    }
    .typeList {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 30px;
      margin: 50px 0;
      .ul {
        width: 20%;
        position: relative;
        .li {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          .label {
            font-size: 14px;
            color: #676779;
            font-weight: bold;
            margin-bottom: 5px;
            width: 65%;
          }
          .unit {
            width: 100%;
            display: flex;
            align-items: center;
            .input {
              margin-right: 5px;
            }
            span {
              font-size: 14px;
            }
          }
        }
      }
      .ul::before {
        content: "";
        position: absolute;
        top: 6%;
        right: -17%;
        width: 1px;
        height: 180px;
        background: #dedede;
      }
      .ul:last-child::before {
        display: none;
      }
    }
  }
  .content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 30px 0;
    border: 1px solid #dedede;
    border-radius: 10px;
    margin: 50px 0;
    .typeList {
      width: 100%;
      padding: 0 20px;
      .title {
        width: 100%;
        font-size: 16px;
        font-weight: bold;
        color: #1a202c;
        text-align: left;
        margin-bottom: 30px;
        position: relative;
      }
      .title::after {
        content: "";
        position: absolute;
        top: 4px;
        left: -8px;
        width: 4px;
        height: 15px;
        background: #5a9cf8;
      }
      .cont {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .li {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          font-size: 14px;
          color: #676779;
          padding-bottom: 10px;

          .value {
            height: 30px;
            line-height: 30px;
            font-size: 16px;
            color: #1a202c;
            font-weight: bold;
            // margin-bottom: 5px;
            span {
              font-size: 14px;
            }
          }
        }
        .lis {
          width: 30%;
          border-bottom: 1px solid #dedede;
          .unit {
            display: flex;
            align-items: center;
            .input {
              width: 100%;
              height: 30px;
              /deep/.el-input__inner {
                border: none !important;
                text-align: center;
                font-size: 16px;
                color: #1a202c;
                font-weight: bold;
              }
            }
          }
        }
      }
    }
    .typeLists {
      border-left: 1px solid #dedede;
      border-right: 1px solid #dedede;
    }
  }
  .footer {
    width: 100%;
    .title {
      width: 100%;
      font-size: 18px;
      font-weight: bold;
      color: #1a202c;
      text-align: left;
      margin-bottom: 30px;
      position: relative;
    }
    .title::after {
      content: "";
      position: absolute;
      top: 6px;
      left: -8px;
      width: 4px;
      height: 15px;
      background: #5a9cf8;
    }
    .foot {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px;
      box-sizing: border-box;
      .left {
        width: 70%;
        height: 300px;
        .statistics {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .li {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            font-size: 14px;
            color: #676779;
            .value {
              font-size: 16px;
              color: #1a202c;
              font-weight: bold;
              margin-bottom: 5px;
            }
          }
        }
        .orderList {
          width: 100%;
          display: flex;
          align-items: flex-start;
          margin-top: 40px;
          .notice {
            width: 20px;
            margin-right: 30px;
            margin-left: 30px;
          }
          .scroll {
            width: 100%;
            overflow: hidden;
            height: 200px;
          }
          .list {
            width: 100%;
            overflow-y: auto;
            margin-bottom: 10px;
            .li {
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-bottom: 10px;
              transition: all 0.5s;
              cursor: pointer;
              &:last-child {
                margin-bottom: 0;
              }
              &:hover {
                color: #5a9cf8;
              }
              .nottitle {
                width: 500px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
              }
            }
          }
        }
      }
      .right {
        width: 30%;
        .myChart {
          width: 100%;
          height: 300px;
        }
      }
    }
  }
}
/deep/ input::-webkit-outer-spin-button,
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
/deep/ input[type="number"] {
  -moz-appearance: textfield;
}
/deep/.el-input.is-disabled .el-input__inner {
  color: #333;
  font-weight: bold;
  border: none;
  background: #fff;
}
</style>